import { getTemplate } from "../template-helper";
import { translateElement } from "../../util/locales";

const COMPONENT_NAME = "z-button-back-to-list" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ButtonBackToListComponent extends HTMLElement {
            constructor() {
                super();
            }

            connectedCallback(){
                this.button = this.querySelector("button") ;
                if(!this.button){
                    const innerHtml = this.innerHTML ;
                    this.innerHTML = "" ;
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    translateElement(this) ;
                    this.button = this.querySelector("button") ;
                    if(innerHtml){
                        this.button.innerHTML = innerHtml ;
                    }
                }
            }

        }
        customElements.define(COMPONENT_NAME, ButtonBackToListComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
